import { HttpHeaders } from "@angular/common/http";
import { FileAction } from "./file-action";


export class DownloadFileAction extends FileAction {

    override execute(val: any, row: any): void {
    console.log("DownloadFileAction", val, row);

    const download = (file: Blob, val: any, headers: HttpHeaders) => {
      // Extract filename if needed, else fallback to val.title
      let filename = val.title || 'downloaded-file';
      const contentDisposition = headers?.get('Content-Disposition');
      const match = contentDisposition?.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }

      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.download = filename;
      a.href = URL.createObjectURL(file);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    };

    super.execute(val, row, download);
  }
}
